import { Component, Input } from '@angular/core';
import { FontService } from '../font.service';
import { FontWeight } from '../../../../../elements/resource/types/shape.type';
import { Store } from '@ngrx/store';
import { setDescriptorValue } from '../../../../store/editor.crud.actions';
import { bulkUpdateFinish } from '../../../../store/editor.actions';

@Component({
  selector: 'nw-font-weight-selector',
  templateUrl: './font-weight-selector.component.html',
  styleUrls: ['./font-weight-selector.component.scss'],
})
export class FontWeightSelectorComponent {
  @Input()
  fontWeight: FontWeight;

  @Input()
  fontFamily: string;

  open = false;

  get isBold() {
    return (
      this.fontWeight == 'bold' ||
      this.fontWeight == '700' ||
      this.fontWeight == '800' ||
      this.fontWeight == '900'
    );
  }

  get isSelectorMode() {
    return this.dropdownElements.length > 2;
  }

  get dropdownElements() {
    const descriptor = this.fontService.descriptors[this.fontFamily];
    if (!descriptor) {
      return;
    }

    if (descriptor.fonts.length > 1) {
      return descriptor.fonts
        .filter(({ style }) => style == 'normal')
        .map(({ weight }) => weight);
    }
  }

  constructor(
    private readonly fontService: FontService,
    private readonly store: Store,
  ) {
    // -- // -- // -- //
  }

  toggleOpen() {
    this.open = !this.open;
  }

  click() {
    // this.toggleOpen();

    // if (this.isSelectorMode) {
    //   this.toggleOpen();
    // } else {
    switch (this.fontWeight) {
      case '600':
      case '700':
      case '800':
      case '900':
      case 'bold':
        this.updateFontWeight('400');
        break;
      default:
        this.updateFontWeight('700');
        break;
    }
    this.finishUpdate();
  }

  updateFontWeight(value: string) {
    this.store.dispatch(
      setDescriptorValue({
        key: 'textConfig',
        innerKey: 'fontWeight',
        value,
      }),
    );
  }

  finishUpdate() {
    this.store.dispatch(bulkUpdateFinish());
  }
}
